import React, { useState } from 'react';
import { Tooltip, Modal } from 'antd';
import { SasProposta, responderRecebimentoPropostaTecnicasProponentes } from '@app/api/sas/sasProposta';
import { Button, FormDatePicker, FormSelect, FormSubmitButton, FormTextArea, MasterDetailForm, Row } from '@digital/ui';
import { UploadMultipleTable, Visibility } from '@app/components';
import { useRecoilState } from 'recoil';
import { modalAcoesIdState, reloadVendorListState } from '../atoms';
import * as Yup from 'yup';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';
import { ETipoContrato } from '@app/enums/ETipoContrato';
import { isObjEmpty, isObjNotEmpty } from '@app/helpers/objHelper';

interface Props {
    sasPropostaId: string;
    sasProposta: SasProposta;
    tipoOrdemCompra: number;
    tipoContrato: string;
}

const ModalNaoRecebimentoPropostaTecnica = (props: Props) => {
    const { sasPropostaId, sasProposta } = props;
    const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
    const [modalAcoesId, setModalAcoesId] = useRecoilState(modalAcoesIdState);
    const [exibirModal, setExibirModal] = useState(false);

    const handleCancel = () => {
        setModalAcoesId('');
        setExibirModal(false);
    };

    const ehAditivo = props.tipoContrato != null && props.tipoOrdemCompra == ETipoDemanda.Aditivo;
    const titulo = ehAditivo ? "Não Aplicável" : "Não Recebimento Proposta Técnica";

    const handleSubmit = (values: any) => {
        const form = new FormData();
        form.append('sasPropostaId', sasPropostaId);
        form.append('justificativa', values.comentarioStatusPropostaTecnica);
        if (ehAditivo) {
            form.append('status', 'Sem Resposta');
        } else {
            form.append('status', values.statusPropostaTecnica);
            form.append('data', values.dataStatusPropostaTecnica);
            values.anexosNaoRecebimentoPropostaTecnica.map((c: any) => {
                form.append("arquivos", c);
            });
        }

        responderRecebimentoPropostaTecnicasProponentes(form)
            .then((data: any) => {
                if (data && data.valid) {
                    setReloadVendorList(!reloadVendorList);
                    handleCancel();
                }
            });
    };

    let validationSchemaTmp: any = {
        comentarioStatusPropostaTecnica: Yup.string().required('O campo é obrigatório.')
    };

    if (!ehAditivo) {
        validationSchemaTmp = {
            ...validationSchemaTmp,
            dataStatusPropostaTecnica: Yup.string().required('O campo é obrigatório.'),
            statusPropostaTecnica: Yup.string().required('O campo é obrigatório.'),
            files: Yup.array().min(1, 'É necessário anexar no mínimo um arquivo.')
        };
    }

    return (
        <Visibility visible={true}>
            <Tooltip title={titulo} >
                <Button icon='commons-cancel' onClick={() => {
                    setExibirModal(true);
                }

                } />
            </Tooltip>
            <Visibility visible={exibirModal} >
                <Modal
                    title={titulo}
                    width="980px"
                    visible={exibirModal}
                    onCancel={handleCancel}
                    footer={null}
                >
                    <MasterDetailForm
                        key={`formNaoRecebimentoPropostaTecnica_${sasPropostaId}`}
                        initialValues={sasProposta}
                        actions={[
                            <Button title='fechar' type='link' onClick={() => handleCancel()} />,
                            !ehAditivo
                                ? <FormSubmitButton title='Salvar' type='primary' noIcon onClick={handleSubmit} />
                                : isObjEmpty(sasProposta.comentarioStatusPropostaTecnica) && <FormSubmitButton title='Salvar' type='primary' noIcon onClick={handleSubmit} />
                        ]
                        }
                        validationSchema={Yup.object().shape(validationSchemaTmp)}
                    >
                        {
                            !ehAditivo &&
                            <Row>
                                <FormDatePicker
                                    label='Data do Registro da Recusa'
                                    name='dataStatusPropostaTecnica'
                                    format='DD/MM/YYYY'
                                    span={6}
                                />
                                <FormSelect
                                    label='Motivo'
                                    name='statusPropostaTecnica'
                                    options={[
                                        { text: 'Declínio', value: 'Declinou' },
                                        { text: 'Não Respondeu', value: 'Sem Resposta' }
                                    ]}
                                    span={6}
                                />
                            </Row>
                        }
                        <Row>
                            <FormTextArea
                                label='Justificativa'
                                name='comentarioStatusPropostaTecnica'
                                rows={3}
                                span={12}
                                disabled={isObjNotEmpty(sasProposta.comentarioStatusPropostaTecnica)}
                            />
                        </Row>
                        {
                            !ehAditivo &&
                            <Row>
                                <UploadMultipleTable
                                    name='anexosNaoRecebimentoPropostaTecnica'
                                    idDoComponente={`formNaoRecebimentoPropostaTecnicaUpload_${sasPropostaId}`}
                                    type='primary'
                                />
                            </Row>
                        }
                    </MasterDetailForm>
                </Modal>
            </Visibility>
        </Visibility>
    );
};

export default ModalNaoRecebimentoPropostaTecnica;